var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      class: _vm.hasError ? "has-error user-selector" : "user-selector",
      attrs: { filterable: "", placeholder: _vm.placeholder },
      on: { change: _vm.onChange },
      model: {
        value: _vm.userFilter,
        callback: function($$v) {
          _vm.userFilter = $$v
        },
        expression: "userFilter"
      }
    },
    [
      _c("el-option", { attrs: { label: _vm.nullLabel, value: null } }),
      _vm._v(" "),
      _vm.includeMe
        ? _c("el-option", {
            attrs: { label: "Me", value: _vm.loggedInUser.id }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.includeReps
        ? _c(
            "el-option-group",
            { attrs: { label: "Reps" } },
            _vm._l(_vm.reps, function(user) {
              return _c("el-option", {
                key: user.id,
                attrs: { label: _vm.userLabel(user), value: user.id }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.includeAdmins
        ? _c(
            "el-option-group",
            { attrs: { label: "Admin" } },
            _vm._l(_vm.admins, function(user) {
              return _c("el-option", {
                key: user.id,
                attrs: { label: _vm.userLabel(user), value: user.id }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.includeDealers
        ? _c(
            "el-option-group",
            { attrs: { label: "Customers" } },
            _vm._l(_vm.dealers, function(user) {
              return _c("el-option", {
                key: user.id,
                attrs: { label: _vm.userLabel(user), value: user.id }
              })
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1441c173", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1441c173","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Common/UserSelector.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1441c173","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Common/UserSelector.vue
// module chunks = 0